import { takeEvery, fork, put, all, call } from "redux-saga/effects";

//Account Redux states
import { UPDATE_USER } from "./actionTypes";
import { updateUserSuccessful, updateUserFailed } from "./actions";
import { logoutUser } from "../../actions";

// Include call API
import { getUsersAPI } from "../../../api/users";

const usersAPI = getUsersAPI();

// Is user register successfull then direct plot user in redux.
function* updateUser({ payload: { user, history } }) {
  console.log(user);
  try {
    const response = yield call(
      usersAPI.updateUser,
      user.name,
      user.new_name,
      user.role_id,
      user.token
    );
    let usr = localStorage.getItem("authUser");
    let pusr = JSON.parse(usr);
    console.log(pusr);
    if (pusr.name === user.name) {
      pusr["name"] = user.new_name;
      localStorage.setItem("authUser", JSON.stringify(user));

      if (user.role_id === 3) {
        yield put(logoutUser(history));
      }
    }
    yield put(updateUserSuccessful(response.message));
  } catch (error) {
    yield put(updateUserFailed(error));
  }
}

export function* watchUserUpdate() {
  yield takeEvery(UPDATE_USER, updateUser);
}

function* updateAccountSaga() {
  yield all([fork(watchUserUpdate)]);
}

export default updateAccountSaga;
